import { Box, BoxProps, ScrollArea } from '@mantine/core'
import useStyles from './index.styles'
import { useContext } from 'react'
import { LeadgenWithBannerContext } from '../context'
import { SoyaForm } from '../soyaForm'
import dynamic from 'next/dynamic'
import { useIsMobile } from 'hooks/useIsMobile'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { Button } from '@hhgtech/hhg-components/mantine'
import { Close } from '@hhgtech/icons/core'
import DoubleArrowRight from 'components/atoms/icons/DoubleArrowRight'
import { useIntl } from 'react-intl'
import { CarePathDefaultContext } from 'components/templates/carePath/landing/context'
import SectionWrapper from '../../sectionWrapper'

const LeadForm = dynamic(() => import('../form').then((res) => res.Form), {
  ssr: false,
})

export const Body = ({
  onDone,
  className,
  styles,
  classNames,
  scrollHeight = 640,
}: { scrollHeight?: number; onDone?: () => void } & BoxProps) => {
  const isMobile = useIsMobile()
  const currentUrl = useCurrentUrl()
  const { formatMessage: f } = useIntl()
  const { detectPage } = useContext(CarePathDefaultContext)
  const { isSoya } = detectPage
  const {
    modalBanner,
    isModal,
    modalStyle,
    data,
    primaryColor,
    onCloseForm,
    close,
    isFullscreenModal,
    scrollable,
    closeBtnProps,
  } = useContext(LeadgenWithBannerContext)
  const { classes, cx } = useStyles(
    { isModal, modalStyle },
    {
      name: 'Form',
      styles,
      classNames,
    },
  )
  const {
    title,
    description,
    ctaButtonTitle: ctaTitle,
    campaigns,
    campaignCode,
    banner,
    termAndCondition: term,
    thankYouMessage,
    isSkippable,
  } = data
  const form = isSoya ? (
    <SoyaForm
      {...{
        className: classes.form,
        title,
        description,
        ctaTitle,
        campaignCode,
        term,
        thankYouMessage,
        primaryColor,
        onDone,
      }}
    />
  ) : (
    <LeadForm
      {...{
        isModal,
        classNames: {
          root: classes.form,
          container: classes.formContainer,
          controlList: classes.formControlList,
          formFrame: classes.formFrame,
          formSubmitBtnWrapper: classes.formSubmitBtnWrapper,
          heading: classes.formHeading,
        },
        campaign: campaigns,
        thankYouMessage,
        isSkippable,
        onClose: (closeThankyou) => {
          closeThankyou()
          isModal && close()
          onCloseForm?.()
        },
      }}
    />
  )
  const _closeBtnProps = {
    dataEventCategory: 'Leadgen Pop Up',
    dataEventAction: 'Close Click',
    dataEventLabel: currentUrl,
    onClick: () => close(),
    ...closeBtnProps,
  }
  const BodyContainer = modalBanner ? SectionWrapper.Wrapper : Box
  return (
    <Box className={cx(className, classes.root)}>
      <Box className={classes.wrapper}>
        {modalBanner && modalBanner}
        <BodyContainer>
          <Box className={classes.container}>
            <Box className={cx(classes.bannerWrapper, 'banner-wrapper')}>
              <img
                className={cx(classes.bannerImg, 'banner-img', 'desktop')}
                src={banner.desktop}
                loading="lazy"
                alt=""
              />
              <img
                className={cx(classes.bannerImg, 'banner-img', 'mobile')}
                src={banner.mobile}
                loading="lazy"
                alt=""
              />
            </Box>
            <Box className={cx(classes.formWrapper, 'form-wrapper')}>
              {!isMobile && (
                <Box
                  id={`datepicker-popover-target`}
                  sx={{
                    position: 'relative',
                    zIndex: 1000,
                  }}
                />
              )}
              {isMobile || !scrollable ? (
                <div className={classes.formFrame}>{form}</div>
              ) : (
                <ScrollArea.Autosize
                  mah={isMobile ? '100%' : scrollHeight}
                  mx="auto"
                  className={cx(classes.formFrame, 'has-scroll')}
                  scrollbarSize={6}
                  type="always"
                  classNames={{
                    thumb: classes.scrollAreaThumb,
                    viewport: classes.scrollAreaViewport,
                    scrollbar: classes.scrollAreaScrollbar,
                  }}
                >
                  {form}
                </ScrollArea.Autosize>
              )}
            </Box>
          </Box>
        </BodyContainer>
      </Box>
      {isSkippable && isModal ? (
        !isMobile && isFullscreenModal ? (
          <Button
            {..._closeBtnProps}
            variant={'white'}
            size={'lg'}
            className={cx(classes.skipBtn, classes.closeBtn)}
            rightIcon={<DoubleArrowRight size={18} color="currentColor" />}
          >
            {f({ id: 'common.skip' })}
          </Button>
        ) : (
          <Button
            {..._closeBtnProps}
            className={cx(classes.closeWithIconBtn, classes.closeBtn)}
            dataEventCategory={'Leadgen Pop Up'}
            rightIcon={<Close size={isMobile ? 18 : 24} />}
          />
        )
      ) : null}
    </Box>
  )
}
